module.exports = __webpack_public_path__ + "img/composer-camera.ed8feb3d.svg";